import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {Widget} from "@ispm/widgets/decorator/widget.decorator";
import {IdynamicFormItem} from "@ispm/dynamic-form/interfaces/IdynamicFormItem";
import {IDynamicFormPagination} from "@ispm/dynamic-form/interfaces/IDynamicFormPagination";
import {get} from 'lodash';

@Component({
  selector: 'ispm-dynamic-form-pagination',
  templateUrl: './dynamic-form-pagination.component.html',
  styleUrls: ['./dynamic-form-pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('DynamicFormPagination')
export class DynamicFormPaginationComponent implements OnInit {
  widgetUpdateValueCallback: (value) => void;
  public selectedIndex = 0;
  public isRightRangeEnabled = false;
  public isLeftRangeEnabled = true;
  public data = [];
  public selectedFormData: any;
  public formId: string;
  public formConfig: IdynamicFormItem[];
  private payload: IDynamicFormPagination;
  public titleParam: string;

  constructor(private _cd: ChangeDetectorRef) {
  }

  ngOnInit(): void {
  }

  /**
   * set DynamicForm Pagination widget config
   * @param _itemConfig
   */
  set widgetConfig(_itemConfig: IdynamicFormItem) {
    this.payload = _itemConfig.widgetPayload;
    if (this.payload) {
      this.formId = get(this.payload, 'formId');
      if (!this.formId) {
        this.formConfig = get(this.payload, 'formConfig');
      }
      this.titleParam = get(this.payload, 'titleParam');
    }
  }

  /**
   * set DynamicForm Pagination widget data
   * @param widgetData
   */
  set widgetData(widgetData: any) {
    if (widgetData && Array.isArray(widgetData) && JSON.stringify(this.data) != JSON.stringify(widgetData)) {
      this.data = widgetData;
      this.selectedIndex = this.data.length - 1;
      this.prepareFormData();
      this.checkNavigationAvailability();
    }

  }

  /**
   * Prepare form data based on selected index
   */
  prepareFormData() {
    this.data = this.data.sort((a, b) => {
      const aDate = new Date(a[this.titleParam]);
      const bDate = new Date(b[this.titleParam]);
      if (aDate instanceof Date && bDate instanceof Date) {
        return (aDate.getTime() > bDate.getTime() ? 1 : -1);
      }
      return 1;
    });
    this.selectedFormData = get(this.data, `[${this.selectedIndex}]`, {});
    this._cd.markForCheck();
  }

  /**
   * Range change based on direction
   * @param direction
   */
  onRangeSelection(direction) {
    if (direction === 'right') {
      this.selectedIndex++;
    }
    if (direction === 'left') {
      this.selectedIndex--;
    }
    this.checkNavigationAvailability();
    this.prepareFormData();
  }

  /**
   * Navigation buttons availability
   */
  checkNavigationAvailability() {
    if (this.data.length == 0 || this.data.length == 1) {
      this.isRightRangeEnabled = false;
      this.isLeftRangeEnabled = false;
      return;
    }
    if (this.selectedIndex == 0) {
      this.isRightRangeEnabled = false;
    } else {
      this.isRightRangeEnabled = true;
    }
    if (this.selectedIndex == this.data.length - 1) {
      this.isLeftRangeEnabled = false;
    } else {
      this.isLeftRangeEnabled = true;
    }
  }
}
